import { constants as callMobileConstants } from '../../../modules/call-mobile';
import { browser } from '../../../common/services/browser';
const MICROPHONE_WIDTH = 7;
const MICROPHONE_HEIGHT = 15;
export class TokboxMicrophoneRenderer {
    constructor(streamId, $rootScope) {
        this.streamId = streamId;
        this.$rootScope = $rootScope;
        this.initCanvasContexts();
        this.handleGalleryViewStatus();
    }
    renderMicrophone(volumeLevel) {
        const fillFrom = Math.round(MICROPHONE_HEIGHT * (1 - volumeLevel / 100.0));
        this.canvasContexts.forEach((context) => {
            // tried rerender only changed part but it had visual bugs
            context.clearRect(0, 0, MICROPHONE_WIDTH, MICROPHONE_HEIGHT);
            context.fillRect(0, fillFrom, MICROPHONE_WIDTH, MICROPHONE_HEIGHT);
        });
        this.renderLevelForMobileUi(this.streamId, volumeLevel);
    }
    initCanvasContexts() {
        this.canvasContexts = [];
        document
            .querySelectorAll(`[data-mic-stream-id="${this.streamId}"]`)
            .forEach((element) => {
            element.width = MICROPHONE_WIDTH;
            element.height = MICROPHONE_HEIGHT;
            const context = element.getContext('2d', {
                alpha: browser.isWithBrokenCanvas(),
            });
            context.fillStyle = '#27ae60';
            context.clearRect(0, 0, MICROPHONE_WIDTH, MICROPHONE_HEIGHT);
            this.canvasContexts.push(context);
        });
    }
    // Todo: remove this method and pass audio level directly to MicLevel component
    renderLevelForMobileUi(streamId, volumeLevel) {
        if (!document.body.classList.contains(callMobileConstants.MOBILE_LAYOUT_BODY_CSS_MODIFIER))
            return;
        const gradientElements = document.querySelectorAll(`stop[data-stream-volume-id="${streamId}"]`);
        [].forEach.call(gradientElements, (element) => {
            element.setAttribute('offset', `${volumeLevel}%`);
        });
    }
    handleGalleryViewStatus() {
        this.$rootScope.$on('galleryViewStatusChanged', (status) => {
            if (status) {
                setTimeout(() => {
                    this.initCanvasContexts();
                }, 500);
            }
        });
    }
}
